import React from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Typography,
  Stack,
  Breadcrumbs,
  Grid,
} from "@mui/material";
import {
  CasinoOutlined as RevolverIcon,
  NavigateNext as NavigateNextIcon,
  AutoAwesome as SparkleIcon,
  Bolt as InstantIcon,
  CheckCircle as VerifiedIcon,
} from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { Path, DEFAULT_CURRENCY } from "../../../../../static/Constants";
import { CommonChip } from "../../../../Components/ui";

const SpinHeroBanner = ({
  totalActive = 0,
  combinedPrize = "0.00",
  currency = DEFAULT_CURRENCY,
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      {/* Breadcrumbs Navigation */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ mb: 2.5 }}
      >
        <Breadcrumbs
          separator={<NavigateNextIcon sx={{ fontSize: 16, color: colors.slate[400] }} />}
          aria-label="breadcrumb"
          sx={{ fontSize: "0.875rem" }}
        >
          <Link
            to={Path.root}
            style={{
              textDecoration: "none",
              color: colors.slate[500],
              fontWeight: 500,
            }}
          >
            Home
          </Link>
          <Link
            to={Path.allLotteries || "/all-lotteries"}
            style={{
              textDecoration: "none",
              color: colors.slate[500],
              fontWeight: 500,
            }}
          >
            All Lotteries
          </Link>
          <Typography
            sx={{
              color: colors.primary.main,
              fontWeight: 600,
              fontSize: "0.875rem",
            }}
          >
            SpinBET Revolver Arena
          </Typography>
        </Breadcrumbs>

      </Stack>

      {/* Hero Banner Box */}
      <Box className="spinner-hero-banner" sx={{ p: { xs: 3, md: 4 } }}>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} md={7}>
            <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 1.5 }}>
              <Box
                sx={{
                  width: 44,
                  height: 44,
                  borderRadius: borderRadiusPx.md,
                  bgcolor: colors.primary.lighter,
                  color: colors.primary.main,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 2px 8px rgba(37, 99, 235, 0.15)",
                }}
              >
                <RevolverIcon sx={{ fontSize: 26 }} />
              </Box>
              <div>
                <Typography variant="overline" sx={{ color: colors.primary.main, fontWeight: 700, letterSpacing: 1.2 }}>
                  LIVE ARENA
                </Typography>
                <Typography variant="h4" className="spinner-hero-title">
                  SpinBET Revolver
                </Typography>
              </div>
            </Stack>

            <Typography variant="body1" sx={{ color: colors.slate[600], maxWidth: 520, lineHeight: 1.6, mb: 2 }}>
              Choose your lucky segment and spin the on-chain roulette wheel. Payouts are executed instantly via smart contracts upon winning!
            </Typography>

            <Stack direction="row" gap={1.5} flexWrap="wrap" sx={{ gap: 1 }}>
              <CommonChip
                icon={<InstantIcon sx={{ fontSize: 16 }} />}
                label="1-Spin Instant Result"
                variant="neutral"
                size="small"
              />
              <CommonChip
                icon={<SparkleIcon sx={{ fontSize: 15 }} />}
                label="Provably Fair VRF"
                variant="neutral"
                size="small"
              />
              <CommonChip
                icon={<VerifiedIcon sx={{ fontSize: 15 }} />}
                label="Direct Wallet Payout"
                variant="neutral"
                size="small"
              />
            </Stack>
          </Grid>

          <Grid item xs={12} md={5}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent={{ md: "flex-end" }}>
              <Box className="spinner-stat-card" sx={{ minWidth: 140 }}>
                <Typography variant="caption" sx={{ color: colors.slate[500], fontWeight: 600, textTransform: "uppercase" }}>
                  Active Wheels
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 800, color: colors.slate[900], my: 0.25 }}>
                  {totalActive}
                </Typography>
                <Typography variant="caption" sx={{ color: colors.emerald[600], fontWeight: 600 }}>
                  Ready to Spin
                </Typography>
              </Box>

              <Box className="spinner-stat-card" sx={{ minWidth: 160 }}>
                <Typography variant="caption" sx={{ color: colors.slate[500], fontWeight: 600, textTransform: "uppercase" }}>
                  Total Prize Pool
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 800, color: colors.primary.main, my: 0.25 }}>
                  {combinedPrize} <span style={{ fontSize: "1rem", fontWeight: 700 }}>{currency}</span>
                </Typography>
                <Typography variant="caption" sx={{ color: colors.slate[500], fontWeight: 500 }}>
                  Across all wheels
                </Typography>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default SpinHeroBanner;
